import React, { useState, useRef } from "react";
import SkeletonArticle from "../../components/Post_skaliton/SkeletonArticle";
import PostContent from "./PostContent";

const Post = ({ posts, status }) => {

  const [allMuted, setAllMuted] = useState(false);
  const [volume, setVolume] = useState(1); // 0 to 1
  const playerRef = useRef(null);

  const handleAllMuteToggle = () => {
    if (playerRef.current) {
      // Toggle the muted state
      const newMutedState = !allMuted;
      playerRef.current.muted = newMutedState;
      setAllMuted(newMutedState);

      setVolume(newMutedState ? 0 : 1);
    }
  };

  const volumeChangeHandler = (e) => {
    const newVolume = e.target.value;
    setVolume(newVolume);
    
    if (playerRef.current) {
      playerRef.current.volume = newVolume;
    }
    
  };
      
  return (
    <center>
        {status &&
          [1, 2, 3, 4].map((i) => <SkeletonArticle key={i} theme="dark" />)}

        {posts &&
          posts.map((data) => <PostContent playerRef={playerRef} volumeChangeHandler={volumeChangeHandler} volume={volume} handleAllMuteToggle={handleAllMuteToggle}
          allMuted={allMuted} key={data.id} post={data} />)}
    
    </center>
  );
};

export default Post;
